import React from "react";

const Java_While = () => {
  return (
    <div>
      <h1>Java While</h1>
      <p>This page provides explanations, examples, and common use-cases for Java While in Java.</p>
    </div>
  );
};

export default Java_While;
